<template>
<div class="total-container">
    <Congrats v-if="finished" />
    <div class="card-top">
        <h4>{{title}}</h4>
        <div class="chart-buttons">
            <div 
            :class="(!singleActive ? 'chart-button-active' : 'chart-button-inactive')" 
            v-on:click="() => { singleActive = false }" 
            class="chart-button chart-button-multi"></div>
            <div 
            :class="(singleActive ? 'chart-button-active' : 'chart-button-inactive')" 
            v-on:click="() => { singleActive = true }" 
            class="chart-button chart-button-single"></div>
        </div>
    </div>
    <div class="mod-count">
        <div class="bottom"><span>Modules Completed: <span class="modColor"> {{ modCount }}</span><span class="ratio1 modColor"> / 3</span></span></div>
        <div class="bottom"><span>Lessons Completed: <span class="lesColor">{{ Object.keys(user.completed).length }}</span><span class="ratio2 lesColor"> / 25</span></span></div>

    </div>
    
    <div class="content-container">
        <div class="chart-container">
            <CircleProgress 
                :snap="snap"
                :single="false"
                :percentageA="user.progress.advisory"
                :percentageM="user.progress.managed_services"
                :percentageO="user.progress.operations"
                :total="user.progress.total"
                :progressColorA="'#20356A'"
                :progressColorM="'rgb(46,79,163)'"
                :progressColorO="'#478A69'"
                :circleColor="'rgba(0,0,0,0.06)'" 
                :strokeWidth="4" 
                :showNumber="true"
                :separated="!singleActive"
            />
        </div>
        <div class="key-container">
            <div class="key key1">
                <div class="key-color">
                    <span>{{user.progress.advisory}}%</span>
                </div>
                Advisory
            </div>
            <div class="key key2">
                <div class="key-color">
                    <span>{{user.progress.managed_services}}%</span>
                </div>
                Managed Services
            </div>
            <div class="key key3">
                <div class="key-color">
                    <span>{{user.progress.operations}}%</span>
                </div>
                Operations
            </div>
        </div>
    </div>
    
</div>
</template>

<script>
import CircleProgress from '../CircleProgress';
import Congrats from "@/components/user_dash/Congrats"

export default { 
  name: 'Total',
  props: {
    user: Object,
    title: String,
    modCount: Number
  },
  components: {
      CircleProgress,
      Congrats
  },
  data() {
      return {
          percent: 0,
          singleActive: false,
          snap: false,
          finished: true
      }
  },
  created() {
      //console.log("created chart");
  },
  mounted() {
      //console.log("user progress: " + this.user.totalProgress);
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
@import '../../assets/global-styles/variables.scss';

.total-container {
    text-align: center;
    padding: $gap;
    height: calc(100% - 64px);
}

.content-container {
    //background: blue;
    width: 100%;
    //height: 100%;
    display:flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top:-24px;

    .chart-container {
        //background: red;
        width: 100%;
        height: 324px;  
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: -24px;

        text {
            font-size: 60pt;
            fill: black;
        }
    }

    #chart {
        height: 100%;
        width: 100%;
        background: green;
    }
}

.key-container {
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: left;
    width:100%;
    margin-top: -52px;

    .key {
        //margin-left: 2px;
        //margin-right: 12px;
        margin:5%;
        display: flex;
        font-weight: bold;
    }

    .key-color {
        background: black;
        border-radius: 24px;
        height: 24px;
        width: 48px;
        margin-right: 12px;
        margin-top: -1px;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        //font-weight: bold;
        
        span {
            color: white !important;
            font-size: 14px;
        }
    }

    .key1 {
        color: $colorDarkBlue;
        
        .key-color {
            background: $colorDarkBlue;
        }
    }

    .key2 {
        color: $colorBlue;
        
        .key-color {
            background: $colorBlue;
        }
    }

    .key3 {
        color: $colorGreen;
        
        .key-color {
            background: $colorGreen;
        }
    }

}
.mod-count{
    float: left;
    text-align: left;
    width:100%;
}
.bottom{
    margin:1%;
}

p {
    margin: 24px 0px;
}
.modColor{
    color: rgb(71,138,105);
    font-weight: bold;
    font-size:18px;

}
.lesColor{
    color: rgb(46,79,163);
    font-weight: bold;
    font-size:18px;
}
.ratio1{
    font-weight: bold;
    font-size: 20px;
}
.card-top {
    display: flex;
    justify-content: space-between;

    .chart-buttons {
        display: inline-flex;

        .chart-button {
            //background: blue;
            height: 24px;
            width: 24px;
            margin-left: 16px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            cursor: pointer;
            opacity: 0.4;
            transition: $animationSpeed;

            &:hover {
                opacity: 0.6;
            }
        }

        .chart-button-active {
            opacity: 1;
        }

        .chart-button-inactive {
            opacity: 0.3;
        }

        .chart-button-single {
            background-image: url('../../assets/icons/single_stroke.svg');
        }

        .chart-button-multi {
            background-image: url('../../assets/icons/multi_stroke.svg');
        }
    }
}
</style>